import React from "react";
import BottomSheetLayout from "../../../../../../components/BottomSheetLayout";
import ActiveFeright from "./ActiveFeright";
import { Box } from "@mui/material";
import CustomButton from "../../../../../../components/CustomButton";

interface Props {
  onDismiss: () => void;
  open: boolean;
}

export default function BarDetailsBottomSheet(props: Props) {
  const { onDismiss, open } = props;

  return (
    <BottomSheetLayout height="100%" onDismiss={onDismiss} open={open}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          padding: "0px 8px 8px 8px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
          }}
        >
          <ActiveFeright />
        </Box>
        <CustomButton
          onClick={onDismiss}
          title="بستن"
          width="100%"
          justifyContent="center"
          bgColor="secondary.main"
          fSize="14px"
          fWeight="700"
          textColor="#fff"
          px="6px"
          py="12px"
          borderRadius="6px"
        />
      </Box>
    </BottomSheetLayout>
  );
}
